module.exports = __webpack_public_path__ + "images/menu-work-sel.svg?562947972b94712cd4df10b8bcf6d144";